module.exports = __webpack_public_path__ + "static/media/civil5.31399376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civil5.jpg
// module id = 5779
// module chunks = 0